import React from "react";

// Find Your Naseeb brand mark — a gold crescent embracing an olive heart.
// Monoline SVG so it stays crisp at any size and can be stroke-animated.
export const BrandEmblem = ({ size = 40, animate = false, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`brand-emblem ${animate ? "emblem-draw" : ""} ${className}`}
    aria-label="Find Your Naseeb"
    role="img"
  >
    <path
      className="emblem-crescent"
      pathLength="100"
      d="M46 13 A24 24 0 1 0 46 51 A19 19 0 1 1 46 13 Z"
      fill="none"
      stroke="#C5A059"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="emblem-heart"
      pathLength="100"
      d="M39 43 C33.5 36.5 28 34.5 28 29 C28 25 31 23 34 24.8 C36 26 38 28 39 29.5 C40 28 42 26 44 24.8 C47 23 50 25 50 29 C50 34.5 44.5 36.5 39 43 Z"
      fill="none"
      stroke="#4A5D23"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BrandEmblem;

// Elegant gold ornament divider (crisp inline SVG — no raster artifacts)
export const GoldDivider = ({ className = "" }) => (
  <svg viewBox="0 0 480 40" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" preserveAspectRatio="xMidYMid meet">
    <defs>
      <linearGradient id="goldFade" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stopColor="#C5A059" stopOpacity="0" />
        <stop offset="0.5" stopColor="#C5A059" stopOpacity="0.9" />
        <stop offset="1" stopColor="#C5A059" stopOpacity="0" />
      </linearGradient>
    </defs>
    <line x1="30" y1="20" x2="196" y2="20" stroke="url(#goldFade)" strokeWidth="1.2" />
    <line x1="284" y1="20" x2="450" y2="20" stroke="url(#goldFade)" strokeWidth="1.2" />
    <g stroke="#C5A059" strokeWidth="1.4" strokeLinejoin="round" fill="none">
      <rect x="228" y="8" width="24" height="24" />
      <rect x="228" y="8" width="24" height="24" transform="rotate(45 240 20)" />
      <path d="M196 20 l7 -7 7 7 -7 7 z" />
      <path d="M270 20 l7 -7 7 7 -7 7 z" />
    </g>
    <circle cx="240" cy="20" r="3" fill="#C5A059" />
  </svg>
);

